/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { createDialogRoute } from '@gh/common-shared';
import { DialogInput } from '@gh/core-ui';
import {
  JeTopViewUsage,
  JeTopViewUsageRecord,
} from '../../../resources/job-estimate-details.model';
import { JeTopUsageGridDefinition } from './je-top-usage-grid-definition.service';

@Component({
  standalone: false,
  selector: 'gh-je-top-usage-dialog',
  templateUrl: 'je-top-usage-dialog.component.html',
  styleUrls: ['je-top-usage-dialog.component.scss'],
  providers: [JeTopUsageGridDefinition],
})
export class JeTopUsageDialogComponent implements DialogInput<JeTopViewUsage> {
  input: JeTopViewUsage;

  constructor(private dialogRef: MatDialogRef<any>,
              public gridDefinition: JeTopUsageGridDefinition) {

  }

  onGoToRecord(record: JeTopViewUsageRecord): void {
    this.dialogRef.close(record);
  }
}

export const jeTopViewUsageDialogRoute = createDialogRoute({
  component: JeTopUsageDialogComponent,
});
